module.exports = __webpack_public_path__ + "img/baipishu-baner.1270fb6a.png";